import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { zhJson } from './locales/zh/index'
import { enJson } from './locales/en/index'
import Cookie from 'project-config/utils/cookie'

i18n
  .use(initReactI18next)
  .init({
    lng: Number(Cookie.getCookie('languageFlag')) === 0 ? 'zh' : 'en',
    debug: false,
    resources: {
      zh: zhJson,
      en: enJson,
    },
    interpolation: {
      escapeValue: false,
    },
  })
  .catch(console.warn)

export default i18n
